/*
 * @format
 */
import moment from 'moment';
import { first, last, get } from 'lodash';
import { EASTERN_NECK_ID } from '../../../ui-permit/src/constants'
import {
    PERMIT_ISSUED,
    PERMIT_COMPLETE,
    LOTTERY_AWARDED,
} from '../constants/shared-constants';
import { issuanceStatuses } from '../../../ui-permit/src/utils/utils';

export const getClassName = (error, displayError) => {
    if (error && displayError) {
        return 'rec-error';
    }
    return '';
};

export const getPermitType = (permit = {}, huntType = '') => (permit.permit_types_list || []).find(({ id }) => id === huntType);
export const getPermitTypeField = (permit = {}, huntType = '', field = 'name', defaultValue) => get(getPermitType(permit, huntType), field, defaultValue);
export const getPermitTypeName = (permit = {}, huntType = '') => getPermitTypeField(permit, huntType, 'name', huntType);
export const isOpenPermitType = (permit = {}, huntType = '') => getPermitTypeField(permit, huntType, 'open');
export const canSelectDate = (permit = {}, huntType = '') => getPermitTypeField(permit, huntType, 'date_select');

export const getHuntingDivisions = (permit = {}, huntType = '', divisionId = '') => {
    const permitType = getPermitType(permit, huntType);
    if (permitType?.open) {
        if (Array.isArray(permitType.divisions)) {
            return permitType.divisions.map((id) => get(permit, ['divisions', id, 'name'], id)).join(', ');
        }
        return 'Open Hunt';
    }
    return permit.divisions?.[divisionId]?.name ?? divisionId;
};

export const getStartAndEndDates = (dates) => [first(dates), last(dates)].map((d, i) => (/\//.test(d) ? (i ? last : first)(d.split('/')) : d));

// Disable sales just for Eastern Neck until August 1st at 10AM ET (on Test and Prod).
export const isSalesDisabled = (permitId) =>
  permitId === EASTERN_NECK_ID && /(recreation.gov)$/.test(window.location.host) && moment("2019-08-01T10:00:00-04:00").isAfter();

export const isIssuedPermit = (reservation) => {
    return (
        reservation.status === issuanceStatuses.get(PERMIT_ISSUED) ||
        reservation.status === issuanceStatuses.get(PERMIT_COMPLETE) ||
        reservation.status === issuanceStatuses.get(LOTTERY_AWARDED)
    );
}
